import { connect } from 'react-redux'
import { getSelf } from '@modules/auth/auth.Dux'
import { difference } from 'lodash'

export const AccessControl = ({ requiredPermission, requiredRole, user, children, exclusiveCompanies, roles }) => {
  if (user.isSuperAdmin) {
    return children
  }

  if (requiredRole && user.profile.type === requiredRole) {
    return children
  }

  if (requiredRole === 'company' && user.isCompanyAdmin) {
    return children
  }

  if (requiredRole === 'provider' && user.isProviderAdmin) {
    return children
  }

  if (roles && roles.includes(user.user.type)) {
    return children
  }

  if (
    exclusiveCompanies &&
    difference(
      exclusiveCompanies.map((co) => co.id),
      user.companies.map((co) => co.id)
    ).length === 0
  ) {
    return children
  }

  if (requiredPermission) {
    return children
  }

  return null
}

const mapStateToProps = (state) => ({
  user: getSelf(state),
})

export default connect(mapStateToProps)(AccessControl)
